import type { CommandBody } from "../CrossOriginMessage";

/**
 * Indicates an order to get the class selected in object list.
 */
export class ObjectListClassRequestCommandBody implements CommandBody {}
